export const wxRoute = {
  path: ':openid/:studentid',
  name: 'home',
  component: () => import('@/components/layout/authority.vue'),
  children: [
    {
      path: 'course',
      name: 'course',
      meta: { title: '我的课程', IsBottomShow: true },
      component: () => import('@/pages/course/index.vue')
    },
    {
      path: 'index',
      name: 'index',
      meta: { title: '学员个人中心', IsBottomShow: true },
      component: () => import('@/pages/index/index')
    },
    {
      path: 'bindstudent',
      name: 'bindstudent',
      meta: { title: '学员绑定' },
      component: () => import('@/pages/index/bindstudent')
    },
    {
      path: 'userInfo',
      name: 'userInfo',
      meta: { title: '编辑学员' },
      component: () => import('@/pages/index/userInfo')
    },
    {
      path: 'coupon',
      name: 'coupon',
      meta: { title: '我的卡券' },
      component: () => import('@/pages/activity/coupon/index.vue')
    },
    {
      path: 'booking',
      name: 'booking',
      meta: { title: '预约记录' },
      component: () => import('@/pages/activity/booking/index.vue')
    },
    {
      path: 'expRecord',
      name: 'expRecord',
      meta: { title: '体验记录' },
      component: () => import('@/pages/activity/expRecord/index.vue')
    },
    {
      path: 'oldBeltNew',
      name: 'oldBeltNew',
      meta: { title: '分享推荐' },
      component: () => import('@/pages/activity/oldBeltNew/index.vue')
    },
    {
      path: 'course/detail/:CourseId',
      name: 'coursedetail',
      meta: { title: '课程详情' },
      component: () => import('@/pages/course/detail/index.vue')
    },
    {
      path: 'bindUserForminiApp',
      name: 'bindUserForminiApp',
      meta: { title: '通知设置' },
      component: () => import('@/pages/authority/bindUserForminiApp.vue')
    },
    {
      path: 'schedule_list',
      name: 'schedule_list',
      meta: { title: '我的课表', IsBottomShow: true },
      component: () => import('@/pages/schedule/index.vue')
    },
    {
      path: 'schedule/list',
      name: 'schedule_list',
      meta: { title: '我的课表' },
      component: () => import('@/pages/schedule/index.vue')
    },
    {
      path: 'homework/list',
      name: 'homework_list',
      meta: { title: '我的作业' },
      component: () => import('@/pages/schedule/homeworkList.vue')
    },
    {
      path: 'leave/:scheduleId',
      name: 'schedule_leave',
      meta: { title: '我的请假' },
      component: () => import('@/pages/schedule/leave.vue')
    },
    {
      path: 'schedule/:scheduleId',
      name: 'schedule',
      meta: { title: '我的课表' },
      component: () => import('@/components/module/schedule/class.vue'),
      children: [
        {
          path: '',
          redirect: 'schedule/list'
        },
        {
          path: 'record',
          name: 'schedule_record',
          meta: { title: '课时记录' },
          component: () => import('@/pages/schedule/record.vue')
        },
        {
          path: 'work',
          name: 'schedule_work',
          meta: { title: '作业' },
          component: () => import('@/pages/schedule/work.vue')
        },
        {
          path: 'prepage',
          name: 'schedule_prepage',
          meta: { title: '教案' },
          component: () => import('@/pages/schedule/prepage.vue')
        }
      ]
    },
    {
      path: 'bookSchedule_list',
      name: 'bookSchedule_list',
      meta: { title: '预约课表', IsBottomShow: true },
      component: () => import('@/pages/bookSchedule/index.vue')
    },
    {
      path: 'bookSchedule/list',
      name: 'bookSchedule_list',
      meta: { title: '预约课表' },
      component: () => import('@/pages/bookSchedule/index.vue')
    },
    {
      path: 'growth',
      name: 'growth',
      meta: { title: '成长记录', IsBottomShow: true },
      component: () => import('@/pages/growth/recordList.vue')
    },
    {
      path: 'notice',
      name: 'notice',
      meta: { title: '我的通知' },
      component: () => import('@/pages/notice/index.vue')
    },
    {
      path: 'notice/detail/:id',
      name: 'noticeDetail',
      meta: { title: '通知详情' },
      component: () => import('@/pages/notice/detail.vue')
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/wxRoute.js